import { getRequest } from "../../../services/RestServices";
import { GET_JOBS_Dropdown } from "../../api/scheduler/url";

export const getDropDownData = async (so_Id) => {
  try {
    return await getRequest(`${GET_JOBS_Dropdown}/${so_Id}`);
  } catch (err) {
    return err;
  }
};
